import React from 'react';
import TagsSelector from 'components/UI/V3/TagsSelector/TagsSelector';
import { Switch } from 'components/UI/V3/Forms/Switch';
import styles from './ClientTagsSection.module.scss';

interface ClientTagsSectionProps {
    enabled: boolean;
    tags: string[];
    availableTags?: Array<{ id: string; name: string }>;
    onChange: (data: { enabled: boolean; tags: string[] }) => void;
}

export const ClientTagsSection: React.FC<ClientTagsSectionProps> = ({ enabled, tags, availableTags, onChange }) => {
    const handleToggle = (value: boolean) => {
        onChange({ enabled: value, tags: value ? tags : [] });
    };

    const handleTagSelect = (tagId: string) => {
        onChange({ enabled, tags: [...tags, tagId] });
    };

    const handleTagRemove = (tagId: string) => {
        onChange({ enabled, tags: tags.filter(id => id !== tagId) });
    };

    const handleSelectAll = (tagIds: string[]) => {
        onChange({ enabled, tags: [...tags, ...tagIds] });
    };

    // Convert tags to format expected by TagsSelector
    const tagOptions =
        availableTags?.map(tag => ({
            id: tag.id,
            name: tag.name,
            isRemovable: true
        })) || [];

    const selectedTags = tagOptions.filter(tag => tags.includes(tag.id));

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.title}>Client Tags</h3>
                <Switch
                    checked={enabled}
                    onChange={handleToggle}
                />
            </div>

            {enabled && (
                <>
                    <p className={styles.description}>Select the client tags that apply to this rate.</p>
                    <TagsSelector
                        title=""
                        direction="down"
                        addButtonColor="black"
                        tags={tagOptions}
                        selected={selectedTags}
                        onSelect={handleTagSelect}
                        onSelectAll={handleSelectAll}
                        onRemove={handleTagRemove}
                    />
                </>
            )}
        </div>
    );
};
